<div class="Calling-container" *ngIf="type == 'call'">
    <div class="calling-body" *ngIf="!smaller">
        <div class="modal-dialog w-100 mx-0" style="border-radius: 16px;">
            <div class="border-0 rounded-4 border-radius" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); ">
                <div class="call-incomming text-white rounded-top-4 row border-radius"
                    style="background-color: #B6CBF3;box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-style: solid; border-color: #FFFFFF; border-width: 1px 1px 1px 2px;">
                    <div class="col-1 px-2"
                        style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                        <div class="h-100 w-100 d-flex align-items-center" (click)="Smaller()">
                            <img class="hw-20" src="assets/images/png/open-right.png" alt="">
                        </div>
                    </div>
                    <div class="col-11 py-3 px-4 border-radius" style="background-color: #2B3038;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="m-0">{{displayPatientName ? displayPatientName : (patient_name ? patient_name : 'Unregistered Caller')}}<span
                                        *ngIf="business_user_name"> ({{business_user_name}})</span></h5>
                                <p class="m-0 pt-1">{{patient_mobile ? (patient_mobile | phoneFormat) : (this.twilio.extra_data?.device_data?.From | phoneFormat)}}</p>
                                <p *ngIf="!twilio.isInCall && !twilio.isCallRejected()" class="fs-16 m-0" style="color: #71757A;">
                                    Ringing....</p>
                                <p *ngIf="twilio.isInCall" class="m-0">Duration: {{ twilio.callDuration }}</p>
                                <p *ngIf="twilio.isInCall && twilio.isReconnecting && !twilio.isCallRejected()"
                                    class="m-0 fw-500" style="color: #FFB020;">Reconnecting…</p>
                                <p *ngIf="twilio.isInCall && !twilio.isReconnecting && twilio.callQualityWarning && !twilio.isCallRejected()"
                                    class="m-0 fw-500" style="color: #FFB020;">{{ twilio.callQualityWarning.includes('bytes-received') ? 'Not receiving audio…' : 'Poor connection' }}</p>
                                <p *ngIf="twilio.isCallRejected()" class="m-0 text-danger fw-500 ">Call Ended</p>
                            </div>
                            <div class="d-flex align-items-center gap-4">
                                <img *ngIf="twilio.showIncoming && !twilio.isInCall"
                                    class="hw-38 p-2 cursor rounded-circle" style="background-color: #18B557;"
                                    src="assets/images/icons/phone-call-white.png" alt="acceptCall"
                                    (click)="acceptCall()" />
                                <img *ngIf="twilio.isInCall" class="hw-38 p-2 cursor rounded-circle"
                                    [style]="twilio.isMuted() == true ? 'background-color: #FDE5E5;' : 'background-color: #F2F5F8;'"
                                    [src]="twilio.isMuted() == true ? 'assets/images/icons/microphone-off.svg' : 'assets/images/icons/microphone.png'"
                                    alt="mute" (click)="twilio.toggleMute()" />
                                <img *ngIf="!twilio.isCallRejected()" class="hw-38 p-2 cursor rounded-circle"
                                    style="background-color: rgba(235, 56, 56, 1);" src="assets/images/svg/phone.svg"
                                    alt="Close" (click)="rejectCall()" /> 
                                    <!-- *ngIf="twilio.isInCall" -->
                                <!-- <img *ngIf="twilio.showIncoming && !twilio.isInCall"
                                    class="hw-38 p-2 cursor rounded-circle"
                                    style="background-color: rgba(235, 56, 56, 1);" src="assets/images/svg/phone.svg"
                                    alt="Close" (click)="rejectCall()" /> -->
                                <img *ngIf="twilio.isCallRejected()" class="hw-38 p-2 cursor rounded-circle"
                                    style="background-color: #F2F5F8; opacity: 50%;"
                                    src="assets/images/icons/microphone-off.svg" alt="mute" />

                                <img *ngIf="twilio.isCallRejected()" class="hw-38 p-2 cursor rounded-circle"
                                    style="background-color: rgba(235, 56, 56, 1); opacity: 50%;"
                                    src="assets/images/svg/phone.svg" alt="Close" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="smaller-modal">
        <div *ngIf="smaller" class="modal-dialog w-100 mx-0">
            <div class="border-0 rounded-4 border-radius" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); ">
                <div class="call-incomming text-white rounded-top-4 row border-radius"
                    style="background-color: #B6CBF3;box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-style: solid; border-color: #FFFFFF; border-width: 1px 1px 1px 2px;">
                   <div class="col-3 p-0">

                       <div class="h-100 px-1 w-100 d-flex align-items-center" (click)="smaller = !smaller"
                           style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                           <img class="hw-20 icon-active" src="assets/images/png/open-right.png" alt="">
                       </div>
                   </div>
                    <div class="col-9 p-0">
                        <div class="py-3 px-4 border-radius" style="background-color: #2B3038;">
                            <h5 class="m-0 text-center padding-custom-y">{{displayPatientNameInnitials ? displayPatientNameInnitials : (patient_name_innitals ? patient_name_innitals : "GU")}}</h5>
                            <img class="hw-27 mt-1 cursor rounded-circle"
                                src="assets/images/icons/phone.png"
                                alt="Close" (click)="rejectCall()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="incomming_alert" *ngIf="twilio.pendingConnection && twilio.activeConnection">
        <div class="call-waiting-alert">
            <h3 class="font-20">New Call Waiting!</h3>
            <p>From: {{ twilio.pendingConnection.parameters.From }}</p>
            <!-- <button class="btn-danger" (click)="twilio.acceptAndDropCurrent()">
                End Current & Answer New
            </button> -->
            <!-- <button (click)="twilio.rejectWaitingCall()">Ignore New</button> -->
        </div>
    </div>
</div>
<!-- <ng-container  *ngIf="type != 'call'">
<div class="alert-body fade-in" >
    <ng-container>
    <div class="alert-box" *ngIf="alert_data?.type == 'SMS_ALERT' && alert_data?.split_req_id" @slideDown>
        <div class="d-flex gap-2 align-items-center">
            <h4 class="m-0 fs-14 fw-600" *ngIf="alert_data?.type == 'SMS_ALERT'">
                You Have a New Message for Account :  <span (click)="Redirect(alert_data[0]?.split_req_id, 1)" style="text-decoration: underline; cursor: pointer;">{{alert_data[0]?.account_id}}</span>
            </h4>
            <img class="hw-20" src="./assets/images/icons/cross-icon.svg" alt="" (click)="notificationclose($event, alert_data)">
        </div>
    </div>
    <div class="alert-box" *ngIf="alert_data?.type == 'NEW_EMAIL' && alert_data?.split_req_id" @slideDown>
        <div class="d-flex gap-2 align-items-center">
            <h4 class="m-0 fs-14 fw-600" *ngIf="alert_data?.type == 'NEW_EMAIL'">
                You Have a New Email for Account : <span (click)="Redirect(alert_data[0]?.split_req_id, 2)" style="text-decoration: underline;cursor: pointer;"> {{alert_data[0]?.account_id}}</span>
            </h4>
            <img class="hw-20" src="./assets/images/icons/cross-icon.svg" alt="" (click)="notificationclose($event, alert_data)">
        </div>
    </div>
    </ng-container>
</div>
</ng-container> -->
